import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import search from "../../../assets/Vehicles/search.png";
import { Plus, Calendar } from "lucide-react";
import close from "../../../assets/Vehicles/close_filter.png";
import fill_chevron_down from "../../../assets/Vehicles/fill_chevron_down.png";
import down from "../../../assets/Vehicles/chevron_down.png";
import Offcanvas from "react-bootstrap/Offcanvas";
import DatePicker from "react-datepicker";
import { useReactTable, getCoreRowModel, getSortedRowModel, getPaginationRowModel, flexRender } from "@tanstack/react-table";
import chevron_down from "../../../assets/Vehicles/chevron_down.png";
import trash from "../../../assets/svg/trash.svg";
import edit from "../../../assets/svg/edit.svg";
import closeoff from "../../../assets/svg/close.svg";
import "../Vehicle_list/List.css";
import Modal from "react-bootstrap/Modal";
import Loading from "../../Loading";
import { geVehicleAssignmentListApi } from "../vehicle-api-new.js";
import { apiCall } from "../../../services/api-service";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import lar from "../../../assets/svg/lar.svg";
import rar from "../../../assets/svg/rar.svg";
import editIcon from "../../../assets/svg/edit.svg";
import delIcon from "../../../assets/svg/delete.svg";
import DeleteModal from "../../common/delete-modal.js";
import { Toast, ToastContainer } from "react-bootstrap";
import VehicleAssignmentForm from "./assignment-create.jsx";
import Spinner from "react-bootstrap/Spinner";
import CommonDropdown from "../../common/common_dropDown";
import { Tooltip } from "react-tooltip";
import { useGlobal } from "../../../GlobalContext.js";

export const Assignment = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { rolePermissionList, userType } = useGlobal();
  //Dropdown Select
  const [selected, setSelected] = useState("Select");
  const handleSelect = useCallback((value) => {
    setSelected(value);
  }, []);
  // Helper for common cell styling
  const renderCell = useCallback(
    (value, maxWidth = "150px") => (
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth,
        }}
      >
        {value}
      </div>
    ),
    []
  );
  const checkPermission = useCallback(
    (menuName, permission) => {
      return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1;
    },
    [rolePermissionList]
  );
    const handleEdit = useCallback((id) => {
    setEditId(id);
  }, []);
  
  const columns = useMemo(
    () => [
      {
        header: "Date",
        accessorKey: "date",
        cell: (info) => renderCell(info.getValue(), "150px"),
      },
      {
        header: "Name",
        accessorKey: "name",
        cell: (info) => renderCell(info.getValue(), "200px"),
      },
      {
        header: "VIN",
        accessorKey: "vin",
        cell: (info) => renderCell(info.getValue(), "200px"),
      },
      {
        header: "License Plate",
        accessorKey: "lic_no",
        cell: (info) => renderCell(info.getValue(), "150px"),
      },
      {
        header: "Type",
        accessorKey: "type",
        cell: (info) => renderCell(info.getValue(), "150px"),
      },
      {
        header: "Group",
        accessorKey: "group",
        cell: (info) => renderCell(info.getValue(), "150px"),
      },
      {
        header: "Current Meter",
        accessorKey: "current_meter",
        cell: (info) => renderCell(info.getValue(), "150px"),
      },
      {
        header: "Assigned To",
        accessorKey: "assignee",
        cell: (info) => {
          return (
            <div
              className="hover-action-cell"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}
            >
              <span>{info.getValue()}</span>
              <div className="click-actions">
                {checkPermission("Vehicle assignment", "edit_permission") && (
                  <button
                    className="icon-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(info.row.original.id);
                    }}
                  >
                    <img src={editIcon} alt="edit" />
                  </button>
                )}
                {checkPermission("Vehicle assignment", "delete_permission") && (
                  <button
                    className="icon-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDeleteId(info.row.original.id);
                    }}
                  >
                    <img src={delIcon} alt="delete" />
                  </button>
                )}
              </div>
            </div>
          );
        },
      },
    ],
    [renderCell, checkPermission, handleEdit]
  );



  // form date
  const [selectedDate, setSelectedDate] = useState();
  // Global filter (search)
  const [globalFilter, setGlobalFilter] = useState("");
  const [sortByValue, setSortByValue] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [sortByField, setSortByField] = useState("created");
  const [sortByDir, setSortByDir] = useState("desc");

  const [vehicleTypeOption, setVehicleTypeOption] = useState(null);
  const [assignedToOption, setAssignedToOption] = useState(null);
  const [groupFilter, setGroupFilter] = useState("");
  const sortByList = [
    { value: "created asc", label: "Created (Oldest)" },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ];

  const handleSelectVehicleType = useCallback((item) => {
    setVehicleTypeOption(item);
  }, []);

  const handleSelectAssignedTo = useCallback((item) => {
    setAssignedToOption(item);
  }, []);

  const [vehicleList, setVehicleList] = useState([]);
  const [vehicleCount, setVehicleCount] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    getVehicleList();
  }, [itemsPerPage, itemOffset, globalFilter, sortByValue, vehicleTypeOption, assignedToOption, selectedDate]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getVehicleList();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [groupFilter]);

  const getVehicleList = useCallback(async () => {
    try {
      const response = await geVehicleAssignmentListApi(
        `search=${globalFilter}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&sort_field=${sortByField}&sort_dir=${sortByDir}&vehicle_type=${vehicleTypeOption != null ? vehicleTypeOption.value : ""}&group=${groupFilter}&assignee=${assignedToOption != null ? assignedToOption.value : ""}&date=${selectedDate != null && selectedDate !== "" ? selectedDate.toLocaleDateString("en-CA") : ""}`
      );
      if (response.data.success === true) {
        setVehicleCount(response.data.total_rec);
        setVehicleList(response.data.assignments);
        setPageCount(response.data.total_pgs);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching vehicle list:", err);
    }
  }, [globalFilter, itemsPerPage, itemOffset, sortByField, sortByDir, vehicleTypeOption, groupFilter, assignedToOption, selectedDate]);

  const handlePageClick = useCallback(
    (event) => {
      const newOffset = (event.selected * itemsPerPage) % (vehicleList.length || 1);
      console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
      setItemOffset(event.selected);
    },
    [itemsPerPage, vehicleList.length]
  );

  const table = useReactTable({
    data: vehicleList ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const { pageIndex, pageSize } = table.getState().pagination;
  const pageOptions = table.getPageOptions();

  // offcanvas
  const [show, setShow] = useState(false);

  const handleClose = useCallback(
    (response) => {
      if (!response || !response.data) {
        setShow(false);
        setEditId(null);
      } else {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setShow(false);
        setEditId(null);
      }
      getVehicleList();
    },
    [getVehicleList]
  );

  const handleShow = useCallback(() => {
    setEditId(null);
    setShow(true);
  }, []);

  const [showRowOffcanvas, setShowRowOffcanvas] = useState(false);
  const [assignmentDetails, setAssignmentDetails] = useState(null);

  const fetchAssignmentDetails = useCallback(async (id) => {
    setLoading(true);
    try {
      const response = await apiCall("get", `vehicle_assignment/view/${id}`);
      if (response.data?.success) {
        setAssignmentDetails(response.data.vehicle_assignment);
        setCurrentKm(response.data.vehicle_assignment.current_km);
        setRemarks(response.data.vehicle_assignment.remarks);
        setSelected(response.data.vehicle_assignment.assign_status);
      } else {
        setAssignmentDetails(null);
      }
    } catch (err) {
      setAssignmentDetails(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleRowClick = useCallback(
    (rowData) => {
      fetchAssignmentDetails(rowData.id);
      setShowRowOffcanvas(true);
    },
    [fetchAssignmentDetails]
  );

  const handleCloseRowOffcanvas = useCallback(() => setShowRowOffcanvas(false), []);

  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null && deleteId !== 0) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const [editId, setEditId] = useState(null);
  useEffect(() => {
    if (editId != null && editId !== 0) {
      setShow(true);
    }
  }, [editId]);


  const cancelDelete = useCallback(() => {
    setDeleteId(null);
    setIsOpenDelete(false);
  }, []);
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      getVehicleList();
    }
  };

  //Status update api

  const [currentKm, setCurrentKm] = useState("");
  const [remarks, setRemarks] = useState("");
  const [statusError, setStatusError] = useState("");
  const [remarksError, setRemarksError] = useState("");

  const updateStatus = useCallback(
    async (id, status) => {
      setLoader(true);
      // Clear previous errors
      setStatusError("");
      setRemarksError("");
      try {
         const response = await apiCall(
        "put",
        `vehicle_assignment/statusupdate/${id}`,
        {
          status: status,
          current_km: currentKm,
          remarks: remarks,
        }
      );

        if (response?.data?.success) {
          handleCloseRowOffcanvas();
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(true);
          handleSnackbarShow();
          setSelected(status);
          getVehicleList();
        } else {
          // Handle validation errors
          if (response?.data?.error) {
            const errors = response.data.error;
            if (errors.status) {
              setStatusError(errors.status.join(", "));
            }
            if (errors.remarks) {
              setRemarksError(errors.remarks.join(", "));
            }
          } else {
            setSnackbarMessage(response?.data?.message || "An error occurred");
            setSnackbarStatus(false);
            handleSnackbarShow();
          }
        }
      } catch (err) {
        setSnackbarMessage(err.message || "An unexpected error occurred");
        setSnackbarStatus(false);
        handleSnackbarShow();
      } finally {
        setLoader(false);
      }
    },
    [currentKm, remarks, getVehicleList, handleCloseRowOffcanvas]
  );

  const handleSave = useCallback(() => {
    if (assignmentDetails && assignmentDetails.id && selected !== "Select") {
      updateStatus(assignmentDetails.id, selected);
    }
  }, [assignmentDetails, selected, updateStatus]);
  const [hoveredRow, setHoveredRow] = useState(null);
  return (
    <>
      {isOpenDelete && <DeleteModal deleteUrl={`vehicle_assignment/delete/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      <div className="bg-half-white w-100">
        <div className="rounded-4" style={{ background: "#FFFFFF", margin: "16px" }}>
          <div className="d-flex p-3 flex-wrap align-items-center justify-content-between">
            <div className="d-flex flex-column">
              <p className="bg-transparent fw-bold dark-purple border-0 fs-24 assigned-dropdowns m-0">Vehicle Assignment</p>
              <p className="text-muted">{vehicleCount} records</p>
            </div>
            <div className="d-flex flex-wrap gap-3">
              <div className="search-wrapper d-flex align-items-center gap-2 bg-white rounded-3 px-3 py-2">
                <img src={search} alt="search" />
                <input
                  type="text"
                  placeholder="Search"
                  className="border-0 outline-0 rounded-3"
                  value={globalFilter || ""}
                  onChange={(e) => {
                    setGlobalFilter(e.target.value);
                    setItemOffset(0);
                  }}
                />
              </div>
              {checkPermission("Vehicle assignment", "create_permission") && (
                <Button className="dark-purple-btn border-0 d-flex gap-1 px-3 rounded-3 text-white" onClick={handleShow}>
                  <Plus />
                  Add new
                </Button>
              )}
              <VehicleAssignmentForm id={editId} show={show} handleClose={handleClose} />
            </div>
          </div>

          {/* Filters */}
          <div className="d-flex flex-wrap align-items-center justify-content-between p-3 gap-2">
            <div className="d-flex flex-wrap align-items-center gap-3">
              <p className="m-0 text-filter-grey fw-semibold">Filter :</p>
              <Dropdown data-tooltip-id="sort-tooltip" data-tooltip-content="Sort by">
                <Dropdown.Toggle id="dropdown-basic" className="bg-white text-purple search-border assigned-dropdown rounded-4 px-4 d-flex align-items-center gap-2">
                  {sortByValue.label}
                  <img src={fill_chevron_down} alt="chev down" />
                  <img src={close} alt="x" />
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                  {sortByList.map((item) => (
                    <Dropdown.Item
                      onClick={() => {
                        const arr = item.value.split(" ");
                        if (arr.length > 1) {
                          setSortByField(arr[0]);
                          setSortByDir(arr[1]);
                        }
                        setSortByValue(item);
                      }}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
                <Tooltip id="sort-tooltip" place="top" />
              </Dropdown>
              <div className="w-15 w-md-25 w-lg-18 d-flex" style={{ maxWidth: "160px" }} data-tooltip-id="vtype-tooltip" data-tooltip-content="Vehicle Type">
                <CommonDropdown apiUrl={`${apiUrl}get_vehicletype`} placeholder="Vehicle Type" value={vehicleTypeOption} onSelect={handleSelectVehicleType} searchView={true} />

                <Tooltip id="vtype-tooltip" place="top" />
              </div>

              <div style={{ maxWidth: "160px" }} className="search-wrapper d-flex align-items-center gap-2 bg-white search-border rounded-4 px-3 py-2">
                <img src={search} alt="search" />
                <input
                  type="text"
                  placeholder="Group"
                  className="border-0 outline-0 rounded-3 text-purple"
                  value={groupFilter || ""}
                  onChange={(e) => {
                    setGroupFilter(e.target.value);
                  }}
                />
              </div>
              <div className="w-15 w-md-25 w-lg-18 d-flex" style={{ maxWidth: "160px" }} data-tooltip-id="vtype-tooltip" data-tooltip-content="Assigned To">
                <CommonDropdown apiUrl={`${apiUrl}get_drivers`} placeholder="Assigned To" value={assignedToOption} onSelect={handleSelectAssignedTo} searchView={true} />

                <Tooltip id="vtype-tooltip" place="top" />
              </div>
              <div className="w-15 w-md-25 w-lg-18 d-flex align-items-center bg-white text-purple search-border rounded-4" style={{ maxWidth: "180px" }} data-tooltip-id="date-tooltip" data-tooltip-content="Date">
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="dd-mm-yyyy"
                  customInput={
                    <button style={{ color: "#8790A1" }} className="border-0 form-control vehicle-form-input bg-white rounded-4 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                      {selectedDate ? selectedDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>}
                      <Calendar size={16} />
                    </button>
                  }
                />
                <Tooltip id="date-tooltip" place="top" />
                {selectedDate != null && <img onClick={() => setSelectedDate(null)} src={close} alt="x" style={{ height: "30px" }} />}
              </div>
            </div>
          </div>
          <Offcanvas show={showRowOffcanvas} onHide={handleCloseRowOffcanvas} placement="end" style={{ maxWidth: "40%" }}>
            {loading ? (
              <Loading />
            ) : (
              <>
                <Offcanvas.Header closeButton={false} className="d-flex justify-content-between align-items-center p-0">
                  <Offcanvas.Title className="bg-grey w-100 p-3 d-flex flex-wrap justify-content-center align-items-center justify-content-xl-between">
                    <div>
                      <p className="m-0 fs-20 fw-800 mb-1">{assignmentDetails.lic_no}</p>
                      <div className="d-flex align-items-center">
                        <span className="me-2 text-muted-grey fs-13 fw-600">{assignmentDetails.name}</span>
                        <span className="me-2" style={{ color: "#D9D9D9" }}>
                          •
                        </span>
                        <span className="border-0 bg-white text-dark-purple py-1 px-4 rounded-pill fs-13 fw-400">
                          <span className="text-muted-grey"> VIN : </span>
                          {assignmentDetails.vin}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex gap-3">
                      <img
                        src={edit}
                        alt="edit"
                        className="cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(assignmentDetails.id);
                          handleCloseRowOffcanvas();
                        }}
                      />
                      <img
                        src={trash}
                        alt="trash"
                        className="cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          setDeleteId(assignmentDetails.id);
                          handleCloseRowOffcanvas();
                        }}
                      />
                      <img src={closeoff} alt="closeoff" className="cursor-pointer" onClick={handleCloseRowOffcanvas} />
                    </div>
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  {assignmentDetails ? (
                    <div>
                      <p className="m-0 fs-15 fw-600">Other details</p>
                      <div className="table-container rounded-4 overflow-hidden my-3">
                        <table className="table table-borderless mb-0">
                          <tbody>
                            <tr>
                              <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                                Type
                              </td>
                              <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                                {assignmentDetails.type}
                              </td>
                            </tr>
                            <tr>
                              <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                                Group
                              </td>
                              <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                                {assignmentDetails.group}
                              </td>
                            </tr>
                            <tr>
                              <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                                Kilometer Driven
                              </td>
                              <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                                {assignmentDetails.km}
                              </td>
                            </tr>
                            <tr>
                              <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                                Assigned to
                              </td>
                              <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                                {assignmentDetails.user}
                              </td>
                            </tr>
                            <tr>
                              <td className="fs-13 fw-500" style={{ color: "#49494B" }}>
                                Date
                              </td>
                              <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                                {assignmentDetails.start_time} / {assignmentDetails.start_date}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <hr />
                      <p className="m-0 pagination-color fs-15 fw-600">
                        Update Status<span className="text-danger">*</span>
                      </p>
                      <label htmlFor="vin" className="form-label fw-400 mt-3" style={{ color: "#8790A1" }}>
                        Update assignment status here
                      </label>
                      <Dropdown
                        className="mb-1"
                        onSelect={(value) => {
                          handleSelect(value);
                          setStatusError("");
                        }}
                      >
                        <Dropdown.Toggle id="vin" className={`bg-white w-100 update-dropdown rounded-3 px-4 d-flex justify-content-between align-items-center gap-2 ${statusError ? "border-danger" : "btn-border-grey"}`} style={{ color: "#172B4D" }} disabled={assignmentDetails.assign_status === "Completed"}>
                          {selected} <img src={chevron_down} alt="chev down" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                          <Dropdown.Item eventKey="Hold">Hold</Dropdown.Item>
                          <Dropdown.Item eventKey="Closed">Closed</Dropdown.Item>
                          <Dropdown.Item eventKey="Completed">Completed</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                      {statusError && <span className="text-danger fs-12 mb-2">{statusError}</span>}
                      <div className="d-flex flex-column">
                        <label htmlFor="current_km">Current KM</label>
                        <input disabled={assignmentDetails.assign_status === "Completed"} type="number" id="current_km" placeholder="Enter here" className="p-2 rounded-3 form-control mt-2" value={currentKm} onChange={(e) => setCurrentKm(e.target.value)} />
                      </div>
                      <div className="d-flex flex-column">
                        <label htmlFor="remarks">
                          Remarks <span className="text-danger">*</span>
                        </label>
                        <textarea
                          disabled={assignmentDetails.assign_status === "Completed"}
                          id="remarks"
                          placeholder="Enter here"
                          className={`p-3 rounded-3 form-control mt-2 ${remarksError ? "border-danger" : ""}`}
                          value={remarks}
                          onChange={(e) => {
                            setRemarks(e.target.value);
                            setRemarksError("");
                          }}
                        ></textarea>
                        {remarksError && <span className="text-danger fs-12 mt-1">{remarksError}</span>}
                      </div>
                      {assignmentDetails.assign_status !== "Completed" && (
                        <div className="d-flex gap-3 justify-content-end mt-5">
                          <Button className="bg-white rounded-3 px-4 py-2 pagination-color btn-border-grey" onClick={handleCloseRowOffcanvas}>
                            Cancel
                          </Button>
                          <Button className="dark-purple-btn rounded-3 py-2 px-4 flex items-center justify-center" onClick={handleSave}>
                            {loader ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" /> : "Save"}
                          </Button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <p>No data available</p>
                  )}
                </Offcanvas.Body>
              </>
            )}
          </Offcanvas>

          {/* Table */}
          <div className="p-3">
            <div className="table-wrapper overflow-x-auto">
              <table>
                <thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th
                          key={header.id}
                          className="px-3 py-2"
                          onClick={header.column.getToggleSortingHandler()}
                          style={{
                            cursor: header.column.getCanSort() ? "pointer" : "default",
                          }}
                        >
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {header.column.getIsSorted() === "asc" && " asc"}
                          {header.column.getIsSorted() === "desc" && " desc"}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row, index) => (
                    <tr
                      key={row.id}
                      style={{
                        position: "relative",
                        backgroundColor: hoveredRow === index ? "#F9F2FF" : "#ffffff",
                        cursor: "pointer",
                        transition: "border-color 0.3s",
                        borderLeft: hoveredRow === index ? "3px solid #471070" : "3px solid #E5E5E5",
                      }}
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                      onClick={() => handleRowClick(row.original)}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="px-3 py-2">
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <img src={down} alt="" />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        table.setPageSize(size);
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end" style={{ zIndex: 9999 }}>
        <Toast className="d-inline-block m-1 z" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
